import * as React from 'react';

import type {User as UserType} from 'nutshell-core/types';

import {colors} from 'shells/colors/colors';
import {StatusDot} from 'shells/status-selector/status-dot';
import type {StatusSelectorOption} from 'shells/status-selector/status-selector';

import type {AgentStatusEnum} from 'nutshell-graphql-types';
import type {GetSessionUser_loggedInUser as User} from 'nutshell-graphql-types';

export const getAgentIsOnline = (
    loggedInUser: UserType | null | undefined | User
): boolean | null | undefined => {
    if (!loggedInUser || !loggedInUser.permissions.canUseInbox) {
        return null;
    }

    return loggedInUser.agentStatus === 'ONLINE';
};

export function getChatStatusText(agentStatus?: AgentStatusEnum | null): string {
    switch (agentStatus) {
        case 'ONLINE':
            return 'Available';
        case 'NOT_ACCEPTING_CHATS':
        default:
            return 'Not accepting chats';
    }
}

export function getChatStatusDescription(agentStatus?: AgentStatusEnum | null): string {
    switch (agentStatus) {
        case 'ONLINE':
            return 'You are ready to chat with visitors from your website';
        case 'NOT_ACCEPTING_CHATS':
        default:
            return 'You are unavailable to receive more chats from visitors';
    }
}

export function getChatStatusIcon(
    agentStatus?: AgentStatusEnum | null
): React.ReactNode | null | undefined {
    switch (agentStatus) {
        case 'NOT_ACCEPTING_CHATS':
            return <StatusDot color={colors.greyLt} />;
        case 'ONLINE':
            return <StatusDot color={colors.success} />;
        default:
            return null;
    }
}

export const CHAT_STATUS_OPTIONS: StatusSelectorOption[] = [
    {
        id: 'ONLINE',
        label: 'Available',
        description: 'You are ready to chat with visitors from your website',
        icon: getChatStatusIcon('ONLINE'),
    },
    {
        id: 'NOT_ACCEPTING_CHATS',
        label: 'Not accepting chats',
        description: 'You are unavailable to receive more chats from visitors',
        icon: getChatStatusIcon('NOT_ACCEPTING_CHATS'),
    },
];
